export const SHORT_LOCAL_DATE_OPTIONS = {
  month: "short",
  day: "numeric",
  year: "numeric",
} as const satisfies Intl.DateTimeFormatOptions;

const isYyyymmddInteger = (value: number) =>
  Number.isInteger(value) && value >= 10000101 && value <= 99991231;

export const parseRandmarDate = (value?: number | string | null): Date | null => {
  if (value === null || value === undefined) return null;

  const numericValue = typeof value === "string" ? Number.parseInt(value, 10) : value;
  if (!Number.isFinite(numericValue) || numericValue <= 0) return null;

  if (isYyyymmddInteger(numericValue)) {
    const year = Math.floor(numericValue / 10000);
    const month = Math.floor((numericValue % 10000) / 100);
    const day = numericValue % 100;

    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
      return null;
    }

    return date;
  }

  const date = new Date(numericValue);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatRandmarDate = (
  value?: number | string | null,
  options: Intl.DateTimeFormatOptions = SHORT_LOCAL_DATE_OPTIONS
) => {
  const date = parseRandmarDate(value);
  return date ? date.toLocaleDateString(undefined, options) : null;
};

